import axios from 'axios';
import Cookies from 'js-cookie';
import { Message, Notification } from 'element-ui';
const service = axios.create({
  timeout: 5 * 60 * 1000,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'Cache-Control': 'no-cache'
  }
});

// 配置所有request
service.interceptors.request.use(
  config => {
    config.headers.authToken = Cookies.get('authToken'); // 所有请求增加authToken
    // config.headers.authToken = '0f82b62ca3cc611a4469ffde18f18fe6'; // 所有请求增加authToken
    return config;
  },
  error => {
    console.log(error);
  }
);

// 配置所有response
service.interceptors.response.use(
  (response: any) => {
    return response;
  },
  error => {
    const res = error.response.data;
    switch (error.response.status) {
      case 400:
        Message({
          message: res.message,
          type: 'warning'
        });
        break;
      case 401:
        if (process.env.NODE_ENV === 'development') { // 开发环境
          (window as any).vm.$router.push({ name: 'login' });
        } else {
          window.location.href = '/'; // 生产环境
        }
        Message({
          message: res.message,
          type: 'warning'
        });
        break;
      case 403:
        Message({
          message: res.message,
          type: 'warning'
        });
        break;
      case 500:
        Notification({
          title: (window as any).vm && (window as any).vm.$t('服务器错误'),
          message: (window as any).vm && (window as any).vm.$t('请联系管理员'),
          position: 'bottom-right'
        });
        break;
    }
    return Promise.reject(error);
  }
);

export default service;
